import axiosInstance from "./axiosInstance";

/** Admin routes are mounted at /v3/admin/users — keep paths under that prefix. */
const loginSessionsService = {
  listActive: async (params = {}) => {
    const res = await axiosInstance.get("admin/users/login-sessions/active", {
      params,
    });
    return res.data;
  },
  listHistory: async (params = {}) => {
    const res = await axiosInstance.get("admin/users/login-sessions/history", {
      params,
    });
    return res.data;
  },
  listByUser: async (userId, params = {}) => {
    const res = await axiosInstance.get(
      `admin/users/${userId}/login-sessions`,
      { params }
    );
    return res.data;
  },
  forceLogoutSession: async (sessionId) => {
    const res = await axiosInstance.delete(
      `admin/users/login-sessions/${sessionId}`
    );
    return res.data;
  },
  forceLogoutSessions: async (sessionIds = []) => {
    const res = await axiosInstance.post(
      "admin/users/login-sessions/revoke-many",
      { sessionIds }
    );
    return res.data;
  },
  forceLogoutAllForUser: async (userId) => {
    const res = await axiosInstance.post(
      `admin/users/${userId}/login-sessions/revoke-all`
    );
    return res.data;
  },
  /** One request — revokes every active session for all users. */
  forceLogoutAllUsers: async () => {
    const res = await axiosInstance.post(
      "admin/users/login-sessions/revoke-all-users",
      { confirm: "LOGOUT ALL" }
    );
    return res.data;
  },
};

export default loginSessionsService;
